import { CalendarEvent } from '../types/calendar'

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const currentDate = today.getDate()

export const mockEvents: CalendarEvent[] = [
  {
    id: 'evt-1',
    leadId: 'L-001',
    leadName: 'Casa Pepe',
    title: 'Demo Growthly — Casa Pepe',
    type: 'Demo',
    start: new Date(
      currentYear,
      currentMonth,
      currentDate,
      10,
      0,
    ).toISOString(),
    end: new Date(currentYear, currentMonth, currentDate, 10, 30).toISOString(),
    attendees: [
      { email: 'pepe@casapepe.es', name: 'José Martínez', status: 'accepted' },
    ],
    organizer: 'setter1@growthly.com',
    status: 'confirmed',
  },
  {
    id: 'evt-2',
    leadId: 'L-002',
    leadName: 'La Tasquita de Enfrente',
    title: 'Propuesta Growthly — La Tasquita',
    type: 'Propuesta',
    start: new Date(
      currentYear,
      currentMonth,
      currentDate,
      12,
      30,
    ).toISOString(),
    end: new Date(currentYear, currentMonth, currentDate, 13, 0).toISOString(),
    attendees: [
      {
        email: 'maria@latasquita.es',
        name: 'María Gómez',
        status: 'tentative',
      },
    ],
    organizer: 'setter1@growthly.com',
    status: 'tentative',
  },
  {
    id: 'evt-3',
    leadId: 'L-003',
    leadName: 'Bar Manolo',
    title: 'Cita Inicial — Bar Manolo',
    type: 'Cita',
    start: new Date(
      currentYear,
      currentMonth,
      currentDate + 1,
      11,
      0,
    ).toISOString(),
    end: new Date(
      currentYear,
      currentMonth,
      currentDate + 1,
      11,
      30,
    ).toISOString(),
    attendees: [
      { email: 'manolo@barmanolo.es', name: 'Manuel Ruiz', status: 'none' },
    ],
    organizer: 'setter1@growthly.com',
    status: 'tentative',
  },
  {
    id: 'evt-4',
    leadId: 'L-004',
    leadName: 'El Rincón Andaluz',
    title: 'Demo Growthly — El Rincón Andaluz',
    type: 'Cancelado',
    start: new Date(
      currentYear,
      currentMonth,
      currentDate - 1,
      16,
      0,
    ).toISOString(),
    end: new Date(
      currentYear,
      currentMonth,
      currentDate - 1,
      16,
      30,
    ).toISOString(),
    attendees: [
      {
        email: 'carmen@rinconandaluz.es',
        name: 'Carmen López',
        status: 'declined',
      },
    ],
    organizer: 'setter1@growthly.com',
    status: 'cancelled',
  },
  {
    id: 'evt-5',
    leadId: 'L-005',
    leadName: 'Pizzeria Bella Roma',
    title: 'Demo Growthly — Bella Roma',
    type: 'Demo',
    start: new Date(
      currentYear,
      currentMonth,
      currentDate + 2,
      18,
      0,
    ).toISOString(),
    end: new Date(
      currentYear,
      currentMonth,
      currentDate + 2,
      18,
      30,
    ).toISOString(),
    attendees: [
      {
        email: 'alessandro@bellaromabilbao.es',
        name: 'Alessandro Rossi',
        status: 'accepted',
      },
    ],
    organizer: 'setter1@growthly.com',
    status: 'confirmed',
  },
]
